import DateUtils from '../date-utils';
import {NotebookTagKeys, NotebookTagPages} from '../../models/static/routes/notebook-tags';

/** Static page titles for notebook export (sync subset of useNotebookTagsInfo). */
const NOTEBOOK_PAGE_TITLES: Record<string, string> = {
    [NotebookTagPages.vendorAccountInfo]: 'Vendor Account Info',
    [NotebookTagPages.vendorAddresses]: 'Vendor Account Info',
    [NotebookTagPages.vendorNotes]: 'Vendor Notes',
    [NotebookTagPages.vendorPurchaseList]: 'Vendor Purchase Orders',
    [NotebookTagPages.vendorPurchaseOrders]: 'Vendor Purchase Orders',
    [NotebookTagPages.vendorPurchaseHistory]: 'Vendor Purchase History',
    [NotebookTagPages.vendorPurchaseOrderSingle]: 'Vendor Purchase Order',
    [NotebookTagPages.vendorPurchaseHistorySingle]: 'Vendor Purchase History',
    [NotebookTagPages.customerProfile]: 'Customer Profile',
    [NotebookTagPages.customerAddresses]: 'Customer Addresses',
    [NotebookTagPages.customerLoginLogs]: 'Customer Login Logs',
    [NotebookTagPages.customerPromotions]: 'Customer Promotions',
    [NotebookTagPages.customerNotes]: 'Customer Notes',
    [NotebookTagPages.customerPriceMatrix]: 'Customer Price Matrix',
    [NotebookTagPages.customerAccountingAvailableCredits]: 'Customer Accounting Available Credits',
    [NotebookTagPages.customerSalesQuotes]: 'Customer Sales Quotes',
    [NotebookTagPages.customerSalesQuoteInformation]: 'Customer Sales Quote Information',
    [NotebookTagPages.customerSalesSalesOrders]: 'Customer Sales Sales-Orders',
    [NotebookTagPages.customerSalesSalesOrderInformation]: 'Customer Sales Sales-Order Information',
    [NotebookTagPages.customerSalesBackOrders]: 'Customer Sales Back-Orders',
    [NotebookTagPages.customerSalesBackOrderInformation]: 'Customer Sales Back-Order Information',
    [NotebookTagPages.customerSalesInvoices]: 'Customer Sales Invoices',
    [NotebookTagPages.customerSalesInvoiceInformation]: 'Customer Sales Invoice Information',
    [NotebookTagPages.customerSalesCredits]: 'Customer Sales Credits',
    [NotebookTagPages.customerSalesCreditInformation]: 'Customer Sales Credit Information',
    [NotebookTagPages.customerSalesShoppingCart]: 'Customer Sales Shopping Cart',
    [NotebookTagPages.customerSalesActiveCards]: 'Customer Sales Active Cards',
    [NotebookTagPages.customerCardSummaryCreditCards]: 'Customer Card Summary Credit Cards',
    [NotebookTagPages.customerCardSummaryGiftCards]: 'Customer Card Summary Gift Cards',
    [NotebookTagPages.customerShippingFeesList]: 'Customer Shipping Fees List',
    [NotebookTagPages.customerShippingFeesSettings]: 'Customer Shipping Fees Settings',
    [NotebookTagPages.customerFormResponses]: 'Customer form responses',
    [NotebookTagPages.ncrList]: 'NCR List',
    [NotebookTagPages.ncrNotes]: 'NCR Notes',
    [NotebookTagPages.ncrTasks]: 'NCR Tasks',
    [NotebookTagPages.ncrInformation]: 'NCR Information',
    [NotebookTagPages.ncrSettings]: 'NCR Settings',
};

export interface NotesCsvExportColumnLabels {
    title: string;
    operator: string;
    modifiedDate: string;
    source: string;
    visibility: string;
    body: string;
    publicVisibility: string;
    privateVisibility: string;
}

/**
 * Resolves a human-readable source title from note tags (sync; no API lookups).
 */
export const getNoteSourceTitleFromTags = (tagList?: Array<{ key?: string; value?: string }>): string => {
    const tags = tagList ?? [];
    const page = tags.find((tag) => tag.key === NotebookTagKeys.page);
    if (!page?.value) {
        return '';
    }
    return NOTEBOOK_PAGE_TITLES[page.value] ?? page.value;
};

/**
 * Builds CSV export payload for note rows (HTML body preserved).
 */
export const buildNotesCsvExportInfo = (
    notes: Array<Record<string, any>>,
    options: {
        title: string;
        columns: NotesCsvExportColumnLabels;
    },
) => ({
    title: options.title,
    body: notes.map((note) => ({
        [options.columns.title]: note.title ?? '',
        [options.columns.operator]: note.createdByName ?? '',
        [options.columns.modifiedDate]: note.modifiedDateTime || note.createdDateTime
            ? DateUtils.serverToLocal(note.modifiedDateTime ?? note.createdDateTime).format(DateUtils.dateTimeFormat)
            : '',
        [options.columns.source]: getNoteSourceTitleFromTags(note.tagList ?? note.tags),
        [options.columns.visibility]: note.isPrivate
            ? options.columns.privateVisibility
            : options.columns.publicVisibility,
        [options.columns.body]: note.body ?? '',
    })),
});
